import { render, staticRenderFns } from "./privacyDialog.vue?vue&type=template&id=73606d00&scoped=true"
import script from "./privacyDialog.vue?vue&type=script&lang=js"
export * from "./privacyDialog.vue?vue&type=script&lang=js"
import style0 from "./privacyDialog.vue?vue&type=style&index=0&id=73606d00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73606d00",
  null
  
)

export default component.exports